import styled from 'styled-components';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body, H5 } from 'syf-component-library/ui/typography';
import query from 'syf-component-library/const/mediaQueries';
export const ContentWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${query.lessThanSmall} {
    margin: auto;
    width: 90%;
  }
`;
export const HeaderTitle = styled(H5) `
  text-align: center;
`;
export const HeaderWrapper = styled(Inset) `
  width: 380px;
`;
export const ImageContainer = styled(Inset) `
  display: flex;
  justify-content: center;
`;
export const Image = styled.img `
  height: auto;
  width: 100%;
  max-width: 144px;
  margin: auto;
  @media ${query.lessThanSmall} {
    max-width: 115px;
  }
`;
export const SelectTheDate = styled(Body) `
  text-align: center;
`;
